var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStrikethrough = function SvgStrikethrough(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M17.597 6.884c-.167-1.5-1.532-4.094-5.563-4.094-4.4 0-5.659 2.953-5.659 4.375 0 2.023.378 3.375 5.66 4.844m-6 5.156c.166 1.5 2.124 4.031 6 4.031 4.4 0 5.739-2.854 5.905-4.187.089-.973-.013-1.886-.96-2.76M2.75 12h18.5"
  })));
};
export default SvgStrikethrough;